
import { Component, Emit, Vue } from 'vue-property-decorator'

import { mock } from '@/tools'

@Component<NSPKLoyaltyRegisterFrameManager>({})
class NSPKLoyaltyRegisterFrameManager extends Vue {
  @Emit()
  success() {
    return
  }

  height = 0
  isLoading = true

  listener(event: MessageEvent) {
    try {
      const data = JSON.parse(event.data)
      if (data.isSuccess) this.success()
      else if (Number.isInteger(data.height)) {
        this.height = data.height
        this.isLoading = false
      }
    } catch (error) {
      mock(error)
    }
  }

  mounted() {
    window.addEventListener('message', this.listener)
  }

  beforeDestroy() {
    window.removeEventListener('message', this.listener)
  }
}

export default NSPKLoyaltyRegisterFrameManager
